<template>
  <ContactUsModal ref="OpenContactUsModal" />
  <v-container fluid class="container-main">
    <v-row justify="center">
      <v-col cols="12" md="11">
        <v-row justify="space-between">
          <v-col cols="10" sm="10" align-self="center">
            <h2 class="text-title">
              {{ t("$vuetify.home.services.title") }}
            </h2>
          </v-col>
          <v-col cols="2" align-self="center">
            <svg width="100%" class="px-md-10" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g class="svg-animation">
                <path
                  d="M62.9163 7.36047C60.8402 7.36047 59.5483 5.9505 59.5483 3.65312V3.64819C59.5483 1.39026 60.8402 0 62.8917 0C64.5781 0 65.6729 0.976138 65.9441 2.28752L65.9638 2.36639H64.6718L64.657 2.31217C64.3858 1.54802 63.7694 1.10432 62.8966 1.10432C61.6145 1.10432 60.8452 2.04102 60.8452 3.63833V3.64326C60.8452 5.27509 61.649 6.25616 62.9311 6.25616C64.0061 6.25616 64.7458 5.59554 64.7705 4.59968L64.7754 4.49122H63.01V3.50029H66.0181V4.26937C66.0181 6.20193 64.8642 7.36047 62.9163 7.36047Z"
                  fill="#101010" />
                <path
                  d="M68.5429 7.44774L69.5789 0.409573L72.3891 0.823031C73.8917 1.04412 74.6861 2.01311 74.4858 3.37392L74.4844 3.38367C74.3451 4.3299 73.725 5.02101 72.8615 5.19794L73.9826 8.2481L72.5483 8.03706L71.5504 5.19938L70.1893 4.99911L69.8016 7.63293L68.5429 7.44774ZM70.3358 4.00411L71.7555 4.21299C72.5507 4.32999 73.0837 3.95993 73.195 3.20393L73.1964 3.19417C73.3048 2.45768 72.8732 1.93573 72.0829 1.81945L70.6876 1.61416L70.3358 4.00411Z"
                  fill="#101010" />
                <path
                  d="M76.8689 8.9292L78.9189 2.11685L83.3294 3.44344L83.0211 4.46789L79.829 3.50775L79.2763 5.3442L82.2938 6.25179L81.9968 7.23847L78.9794 6.33088L78.3955 8.2712L81.5877 9.23134L81.2794 10.2558L76.8689 8.9292Z"
                  fill="#101010" />
                <path
                  d="M84.6055 11.5212L87.6259 5.07987L91.7962 7.03433L91.342 8.00299L88.3236 6.58841L87.5094 8.32484L90.3625 9.662L89.9251 10.5949L87.0719 9.25779L86.2117 11.0924L89.23 12.507L88.7758 13.4757L84.6055 11.5212Z"
                  fill="#101010" />
                <path
                  d="M91.1391 14.7202L95.0654 8.78717L96.0195 9.41826L96.1599 15.4874L96.1846 15.5037L98.9354 11.3469L99.9883 12.0433L96.062 17.9763L95.1161 17.3507L94.9784 11.2596L94.9578 11.246L92.1961 15.4193L91.1391 14.7202Z"
                  fill="#101010" />
                <path
                  d="M98.1082 19.532L101.435 12.9606L102.42 13.8423L99.758 18.6665L99.7763 18.683L104.421 15.6352L105.281 16.4051L102.759 21.3544L102.777 21.3708L107.282 18.1981L108.267 19.0798L102.097 23.1049L101.182 22.2857L103.519 17.5281L103.497 17.5084L99.0227 20.3512L98.1082 19.532Z"
                  fill="#101010" />
                <path
                  d="M105.791 27.3565C104.459 25.7574 104.718 23.8557 106.457 22.4082L106.465 22.4019C108.201 20.9575 110.125 21.0567 111.45 22.6482C112.778 24.2436 112.519 26.1453 110.783 27.5896L110.776 27.5959C109.036 29.0434 107.122 28.9557 105.791 27.3565ZM106.64 26.6501C107.463 27.6392 108.744 27.6059 109.949 26.6031L109.957 26.5968C111.17 25.5876 111.414 24.3323 110.601 23.3546C109.79 22.3807 108.511 22.3862 107.295 23.3985L107.287 23.4048C106.07 24.4171 105.826 25.6724 106.64 26.6501Z"
                  fill="#101010" />
                <path
                  d="M109.316 31.7285L115.39 28.0225L116.87 30.4465C117.661 31.7426 117.424 32.9729 116.25 33.6894L116.242 33.6946C115.425 34.1928 114.497 34.1584 113.809 33.608L112.181 36.4206L111.425 35.1834L112.969 32.6015L112.252 31.4274L109.979 32.8142L109.316 31.7285ZM113.111 30.9034L113.858 32.128C114.277 32.814 114.903 32.9868 115.555 32.5887L115.563 32.5836C116.199 32.1958 116.324 31.5303 115.908 30.8486L115.173 29.645L113.111 30.9034Z"
                  fill="#101010" />
                <path
                  d="M113.503 39.074L120.052 36.2917L120.549 37.4623L114.985 39.8262L116.248 42.7982L115.264 43.2166L113.503 39.074Z"
                  fill="#101010" />
                <path
                  d="M116.309 46.1028L123.193 44.3035L123.851 46.8171C124.387 48.8681 123.466 50.4133 121.29 50.9819L121.281 50.9844C119.101 51.5543 117.505 50.677 116.966 48.6165L116.309 46.1028ZM117.671 47.0616L117.973 48.2158C118.334 49.5991 119.378 50.1415 120.948 49.7312L120.958 49.7287C122.494 49.3272 123.135 48.3291 122.777 46.9602L122.475 45.8059L117.671 47.0616Z"
                  fill="#101010" />
                <path d="M121.236 63.4269L122.33 63.4669L122.213 66.6446L121.119 66.6046L121.236 63.4269Z"
                  fill="#101010" />
                <path
                  d="M116.73 78.5924L123.464 80.8894L122.579 83.4837C122.114 84.8461 120.897 85.4674 119.548 85.0074L119.538 85.0042C118.194 84.5458 117.606 83.3084 118.071 81.946L118.545 80.5555L116.319 79.7962L116.73 78.5924ZM121.696 82.8492L122.069 81.7573L119.516 80.8866L119.143 81.9785C118.849 82.8417 119.143 83.5048 119.951 83.7801L119.96 83.7833C120.768 84.0587 121.402 83.7124 121.696 82.8492Z"
                  fill="#101010" />
                <path
                  d="M114.257 85.5419L119.422 91.057L118.768 92.3285L111.277 91.3381L111.888 90.1499L113.799 90.4558L115.009 88.1014L113.649 86.7256L114.257 85.5419ZM117.975 91.1003L115.736 88.835L114.818 90.6194L117.962 91.1266L117.975 91.1003Z"
                  fill="#101010" />
                <path
                  d="M109.978 93.4024L115.765 97.5417L114.113 99.8512C113.229 101.086 112.004 101.349 110.885 100.549L110.877 100.543C110.099 99.9868 109.767 99.1194 110.005 98.2709L106.779 97.873L107.622 96.6942L110.603 97.1045L111.404 95.9858L109.238 94.4368L109.978 93.4024ZM112.222 96.571L111.387 97.7378C110.919 98.3913 111.005 99.0344 111.626 99.479L111.634 99.4848C112.24 99.9179 112.901 99.7729 113.366 99.1233L114.187 97.9766L112.222 96.571Z"
                  fill="#101010" />
                <path
                  d="M103.851 101.167L108.203 105.362L109.682 103.828L110.452 104.571L106.619 108.546L105.849 107.803L107.324 106.274L102.972 102.079L103.851 101.167Z"
                  fill="#101010" />
                <path
                  d="M99.7152 105.277L104.064 110.908L103.159 111.607L97.3678 109.78L97.3444 109.798L100.391 113.743L99.3922 114.514L95.0432 108.883L95.9409 108.19L101.752 110.027L101.771 110.012L98.7121 106.051L99.7152 105.277Z"
                  fill="#101010" />
                <path
                  d="M92.3997 110.604L95.8823 116.807L91.8658 119.061L91.3421 118.128L94.2491 116.497L93.3103 114.825L90.5624 116.366L90.058 115.468L92.8059 113.926L91.8139 112.159L88.907 113.79L88.3832 112.857L92.3997 110.604Z"
                  fill="#101010" />
                <path
                  d="M85.4408 114.267L87.9827 120.911L85.3298 121.926C83.9112 122.468 82.744 122.012 82.2525 120.727L82.249 120.718C81.9073 119.825 82.1097 118.919 82.776 118.342L80.3052 116.231L81.6593 115.713L83.9187 117.699L85.2037 117.208L84.2524 114.721L85.4408 114.267ZM85.5631 118.147L84.2228 118.66C83.472 118.947 83.1884 119.53 83.4614 120.244L83.465 120.253C83.7309 120.948 84.3628 121.192 85.109 120.907L86.4263 120.403L85.5631 118.147Z"
                  fill="#101010" />
                <path
                  d="M69.4389 118.574L69.9583 125.669L65.4336 126L65.3555 124.933L68.6113 124.695L68.4576 122.595L65.4822 122.813L65.4066 121.781L68.382 121.563L68.17 118.667L69.4389 118.574Z"
                  fill="#101010" />
                <path
                  d="M59.0567 118.629C61.1322 118.781 62.3223 120.287 62.1571 122.544L62.1564 122.554C61.9915 124.806 60.5849 126.121 58.5193 125.97C56.4488 125.819 55.2586 124.313 55.4235 122.061L55.4242 122.051C55.5894 119.794 56.9813 118.477 59.0567 118.629ZM58.9761 119.731C57.6925 119.637 56.8272 120.582 56.7128 122.145L56.712 122.155C56.5969 123.729 57.3311 124.776 58.5999 124.869C59.8639 124.961 60.7474 124.037 60.8629 122.459L60.8636 122.449C60.9792 120.871 60.245 119.824 58.9761 119.731Z"
                  fill="#101010" />
                <path
                  d="M53.4609 118.132L51.9137 125.076L49.1412 124.459C47.6588 124.129 46.9372 123.104 47.2364 121.762L47.2385 121.752C47.4465 120.819 48.1154 120.175 48.9895 120.061L48.0941 116.937L49.5092 117.252L50.2972 120.155L51.6401 120.454L52.2191 117.856L53.4609 118.132ZM51.4213 121.436L50.0207 121.124C49.2361 120.949 48.6775 121.28 48.5113 122.025L48.5092 122.035C48.3473 122.762 48.7396 123.314 49.5194 123.487L50.896 123.794L51.4213 121.436Z"
                  fill="#101010" />
                <path
                  d="M37.7389 112.898L34.2563 119.101L30.2398 116.848L30.7635 115.915L33.6705 117.546L34.6094 115.874L31.8615 114.332L32.3659 113.433L35.1138 114.975L36.1057 113.208L33.1987 111.577L33.7224 110.644L37.7389 112.898Z"
                  fill="#101010" />
                <path
                  d="M31.545 109.299L27.5195 110.72L27.5105 110.731L27.1804 114.918L25.99 113.999L26.319 110.87L26.2761 110.837L23.3359 111.95L22.2079 111.079L26.2592 109.722L26.2682 109.71L26.5881 105.472L27.7474 106.367L27.4779 109.467L27.5131 109.494L30.4483 108.452L31.545 109.299Z"
                  fill="#101010" />
                <path
                  d="M22.8026 101.615C24.223 103.088 24.1045 104.996 22.4679 106.574L22.4644 106.577C20.8278 108.155 18.9194 108.193 17.5024 106.724C16.3661 105.545 16.2658 103.971 17.1795 102.83L17.2116 102.792L18.0775 103.69L18.0272 103.773C17.5852 104.487 17.6542 105.29 18.2976 105.957C19.1602 106.851 20.4248 106.735 21.5608 105.64L21.5643 105.637C22.7039 104.538 22.8665 103.272 22.0074 102.381C21.3777 101.728 20.5847 101.609 19.7919 102.051L19.7461 102.075L18.8802 101.177L18.9226 101.15C20.1 100.268 21.6663 100.437 22.8026 101.615Z"
                  fill="#101010" />
                <path
                  d="M18.9726 97.4558L13.1854 101.595L12.4451 100.561L17.362 97.0438L15.4826 94.4176L16.3529 93.7951L18.9726 97.4558Z"
                  fill="#101010" />
                <path
                  d="M13.4756 88.5443C14.3009 90.149 13.8721 91.6333 12.4731 92.3524L8.37697 94.4578L7.79523 93.3266L11.7993 91.2686C12.6764 90.8177 12.9758 89.9875 12.4933 89.0492C12.0108 88.111 11.1634 87.8757 10.2863 88.3266L6.28227 90.3847L5.7028 89.2579L9.79892 87.1525C11.1979 86.4334 12.6481 86.9352 13.4756 88.5443Z"
                  fill="#101010" />
                <path
                  d="M10.3355 81.1851C10.8625 82.7295 10.4816 83.995 9.29983 84.4866L9.23142 84.5151L8.83814 83.3627L8.89096 83.3342C9.43944 83.0482 9.5966 82.333 9.30841 81.4885C9.01863 80.6393 8.45908 80.2363 7.88035 80.4337L7.87568 80.4353C7.37163 80.6072 7.22035 81.0495 7.33448 81.9794L7.43193 82.7536C7.60875 84.1726 7.2156 85.036 6.21216 85.3782L6.2075 85.3798C5.02045 85.7795 3.86264 85.0127 3.36747 83.5616C2.86592 82.0919 3.31267 80.8664 4.44157 80.4033L4.51932 80.3716L4.9126 81.524L4.85978 81.5525C4.29878 81.8324 4.12548 82.4697 4.38342 83.2255C4.65717 84.0125 5.19306 84.3767 5.72978 84.1936L5.73444 84.192C6.21049 84.0297 6.36474 83.5655 6.25571 82.6964L6.15667 81.9175C5.96837 80.4191 6.32919 79.6136 7.37929 79.2555L7.38396 79.2539C8.63942 78.8257 9.77505 79.5427 10.3355 81.1851Z"
                  fill="#101010" />
                <path d="M8.26745 74.0505L1.27001 75.3426L1.03892 74.0919L8.03636 72.7997L8.26745 74.0505Z"
                  fill="#101010" />
                <path
                  d="M7.25514 66.0693L0.234131 68.7925L0.183523 67.4081L5.87347 65.3946L5.87257 65.37L0.0506083 63.7722L0 62.3878L7.20129 64.5962L7.25514 66.0693Z"
                  fill="#101010" />
                <path
                  d="M7.26112 59.289L0.188003 58.5109L0.691746 53.9339L1.75541 54.0509L1.39082 57.3636L3.29757 57.5734L3.64221 54.442L4.66666 54.5547L4.32202 57.6861L6.33661 57.9077L6.7012 54.595L7.76486 54.712L7.26112 59.289Z"
                  fill="#101010" />
                <path
                  d="M11.6888 41.4088C11.0504 42.9106 9.92194 43.599 8.71369 43.1767L8.64368 43.1523L9.12006 42.0316L9.17837 42.0457C9.77779 42.1986 10.3722 41.7708 10.7213 40.9495C11.0723 40.1237 10.9245 39.4503 10.3618 39.2112L10.3572 39.2093C9.86707 39.0011 9.45919 39.2295 8.92346 39.9983L8.47929 40.6398C7.66379 41.8147 6.7947 42.1954 5.81893 41.7808L5.8144 41.7789C4.66355 41.2846 4.31302 39.9412 4.91283 38.5301C5.52035 37.1008 6.67104 36.4862 7.82097 36.8944L7.90005 36.9226L7.42368 38.0433L7.36536 38.0293C6.76072 37.8635 6.20626 38.2225 5.89382 38.9575C5.57242 39.7263 5.72845 40.355 6.25037 40.5768L6.25491 40.5787C6.71784 40.7754 7.14251 40.5326 7.64147 39.8125L8.08757 39.1664C8.94755 37.9248 9.75389 37.5656 10.775 37.9994L10.7796 38.0014C12.0004 38.52 12.3676 39.8116 11.6888 41.4088Z"
                  fill="#101010" />
                <path
                  d="M14.1369 35.9827L8.06294 32.2767L10.4623 28.3463L11.3757 28.9036L9.63913 31.7483L11.2765 32.7474L12.9181 30.0583L13.7978 30.5951L12.1563 33.2841L13.8863 34.3397L15.6229 31.4949L16.5363 32.0522L14.1369 35.9827Z"
                  fill="#101010" />
                <path
                  d="M18.4123 29.3833L12.9428 24.8326L14.7597 22.6499C15.7312 21.4828 16.9724 21.3096 18.0299 22.1895L18.0375 22.1958C18.7729 22.8076 19.0399 23.6968 18.7412 24.5258L21.9294 25.158L21.0021 26.2721L18.0594 25.6454L17.1793 26.7027L19.2261 28.4056L18.4123 29.3833ZM16.4061 26.0593L17.324 24.9566C17.8382 24.3389 17.7999 23.6913 17.2123 23.2025L17.2048 23.1962C16.6324 22.72 15.962 22.8164 15.4509 23.4303L14.5488 24.5141L16.4061 26.0593Z"
                  fill="#101010" />
                <path
                  d="M25.0411 22.1304L18.4562 18.4771L19.4883 17.5526L24.676 20.6371L24.6944 20.6206L22.1987 15.1247L23.2307 14.2002L26.1392 21.1467L25.0411 22.1304Z"
                  fill="#101010" />
                <path d="M31.4966 16.9786L27.5704 11.0456L28.6314 10.3438L32.5577 16.2768L31.4966 16.9786Z"
                  fill="#101010" />
                <path
                  d="M39.5182 12.5602C37.6652 13.4286 35.8968 12.7002 34.9318 10.6424L34.9297 10.6379C33.9648 8.58007 34.5447 6.762 36.3932 5.89567C37.8756 5.20094 39.3983 5.61436 40.1833 6.84722L40.2087 6.88976L39.0791 7.41919L39.017 7.34483C38.4841 6.69619 37.7015 6.50217 36.862 6.89557C35.7369 7.4229 35.4387 8.65704 36.1085 10.0855L36.1106 10.0899C36.7825 11.5228 37.9286 12.0855 39.0493 11.5603C39.8709 11.1753 40.2397 10.4634 40.0769 9.57048L40.0694 9.51956L41.1991 8.99014L41.2111 9.03897C41.6654 10.4377 41.0006 11.8655 39.5182 12.5602Z"
                  fill="#101010" />
                <path
                  d="M44.6921 10.2795L42.642 3.46716L47.0525 2.14057L47.3608 3.16502L44.1686 4.12516L44.7213 5.96161L47.7388 5.05402L48.0357 6.0407L45.0182 6.94829L45.6021 8.88861L48.7943 7.92846L49.1026 8.95291L44.6921 10.2795Z"
                  fill="#101010" />
                <path
                  d="M54.7728 7.97462C53.1579 8.21221 51.9824 7.60781 51.7135 6.35676L51.6978 6.28431L52.9029 6.10701L52.9212 6.16411C53.103 6.75527 53.7778 7.03967 54.6609 6.90975C55.5488 6.77911 56.0468 6.30221 55.9578 5.6974L55.9571 5.69252C55.8795 5.16576 55.472 4.9367 54.5365 4.87999L53.7574 4.83518C52.3295 4.75127 51.5517 4.20793 51.3973 3.15928L51.3966 3.1544C51.2191 1.91481 52.1835 0.91582 53.7008 0.692582C55.2376 0.466472 56.3618 1.12826 56.6123 2.32222L56.6294 2.40442L55.4244 2.58172L55.406 2.52463C55.2326 1.92227 54.6372 1.63614 53.8469 1.75242C53.0231 1.87861 52.5675 2.3393 52.6501 2.90021L52.6508 2.90509C52.7241 3.40259 53.1526 3.63853 54.0273 3.68921L54.8114 3.73332C56.3195 3.82037 57.0462 4.32139 57.2077 5.41882L57.2085 5.42369C57.4016 6.73573 56.4901 7.72195 54.7728 7.97462Z"
                  fill="#101010" />

              </g>
              <g>
                <path
                  d="M75.9279 60.287C75.8453 60.0148 75.6862 59.7744 75.471 59.5968C75.2557 59.4192 74.9942 59.3126 74.7201 59.2905L68.7752 58.757C68.7392 58.7533 68.7049 58.7396 68.6758 58.7173C68.6468 58.695 68.6241 58.6649 68.6102 58.6303L66.2876 52.8837C66.18 52.6215 66.0006 52.398 65.7716 52.2409C65.5427 52.0838 65.2743 52 64.9998 52C64.7254 52 64.4569 52.0838 64.228 52.2409C63.999 52.398 63.8196 52.6215 63.712 52.8837L61.3894 58.6303C61.3755 58.6649 61.3528 58.695 61.3238 58.7173C61.2947 58.7396 61.2604 58.7533 61.2245 58.757L55.2795 59.2905C55.0054 59.3126 54.7439 59.4192 54.5287 59.5968C54.3134 59.7744 54.1543 60.0148 54.0717 60.287C53.9843 60.5597 53.9766 60.8531 54.0498 61.1303C54.1229 61.4074 54.2735 61.6558 54.4826 61.8441L58.9929 65.9288C59.0205 65.9543 59.041 65.987 59.0522 66.0235C59.0635 66.06 59.0651 66.099 59.0568 66.1364L57.7011 72.21C57.6379 72.4897 57.6559 72.7825 57.7529 73.0515C57.8499 73.3205 58.0215 73.5536 58.246 73.7214C58.467 73.8907 58.7319 73.9874 59.0063 73.9988C59.2808 74.0103 59.5523 73.9361 59.7857 73.7858L64.8958 70.5678C64.9259 70.5485 64.9605 70.5383 64.9958 70.5383C65.0311 70.5383 65.0658 70.5485 65.0958 70.5678L70.2059 73.7858C70.4418 73.9357 70.7151 74.0097 70.9914 73.9985C71.2678 73.9873 71.5347 73.8913 71.7586 73.7228C71.9825 73.5542 72.1532 73.3206 72.2493 73.0513C72.3454 72.7821 72.3625 72.4893 72.2985 72.21L70.9468 66.1343C70.9385 66.097 70.9401 66.058 70.9514 66.0214C70.9626 65.9849 70.9831 65.9522 71.0108 65.9267L75.521 61.842C75.729 61.6534 75.8786 61.4051 75.951 61.1285C76.0234 60.8518 76.0154 60.559 75.9279 60.287ZM74.7281 60.9016L70.2179 64.9863C70.0257 65.1599 69.8828 65.3846 69.8046 65.6363C69.7264 65.888 69.7158 66.1571 69.774 66.4146L71.1257 72.4903C71.1357 72.5311 71.1335 72.5741 71.1194 72.6136C71.1053 72.6531 71.08 72.6872 71.0468 72.7114C71.0167 72.7364 70.9797 72.7508 70.9412 72.7525C70.9028 72.7541 70.8648 72.743 70.8328 72.7207L65.7227 69.5028C65.5048 69.3653 65.2548 69.2926 64.9998 69.2926C64.7449 69.2926 64.4948 69.3653 64.2769 69.5028L59.1668 72.7207C59.1348 72.743 59.0968 72.7541 59.0584 72.7525C59.0199 72.7508 58.9829 72.7364 58.9529 72.7114C58.9196 72.6872 58.8943 72.6531 58.8802 72.6136C58.8661 72.5741 58.8639 72.5311 58.8739 72.4903L60.2256 66.4146C60.2838 66.1571 60.2733 65.888 60.195 65.6363C60.1168 65.3846 59.9739 65.1599 59.7817 64.9863L55.2715 60.9016C55.2407 60.8743 55.2185 60.838 55.208 60.7974C55.1974 60.7568 55.199 60.7139 55.2125 60.6742C55.2226 60.6348 55.2445 60.5996 55.275 60.5739C55.3056 60.5481 55.3432 60.5331 55.3825 60.531L61.3284 59.9974C61.583 59.9749 61.8268 59.8805 62.0333 59.7244C62.2399 59.5683 62.4013 59.3565 62.5002 59.112L64.8228 53.3654C64.839 53.3297 64.8646 53.2995 64.8966 53.2784C64.9287 53.2573 64.9658 53.2461 65.0038 53.2461C65.0418 53.2461 65.0789 53.2573 65.111 53.2784C65.143 53.2995 65.1686 53.3297 65.1848 53.3654L67.4994 59.112C67.598 59.3559 67.7588 59.5674 67.9646 59.7234C68.1704 59.8794 68.4133 59.9742 68.6672 59.9974L74.6131 60.531C74.6524 60.5331 74.69 60.5481 74.7206 60.5739C74.7511 60.5996 74.773 60.6348 74.7831 60.6742C74.7971 60.7135 74.7993 60.7562 74.7895 60.7967C74.7797 60.8373 74.7583 60.8738 74.7281 60.9016Z"
                  fill="#343330" />
              </g>
            </svg>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-14 row-services mx-sm-0">
          <!-- cols = 9 -->
          <v-col cols="12" sm="4" md="3" class="pa-1">
            <v-img width="100%" height="100%" cover class="discover-img"
              src="../../assets/img/Home/Discover.jpg"></v-img>
          </v-col>
          <v-col cols="12" sm="4" md="3" class="pa-1" v-for="(service, index) in services" :key="index">
            <v-card class="cards-services pa-4" flat @click="OpenModal(service)">
              <div>
                <v-row class="ma-0">
                  <div class="vip-text fontRaleway py-1 px-3">
                    <span style="color: #DF6322;">VIP</span> Service
                  </div>
                </v-row>
                <v-card-title class="cards-title-text fontSFProR px-0 mt-4">
                  {{ t(`$vuetify.home.services.services[${index}].title`) }}
                </v-card-title>
                <v-card-text class="cards-text fontSFProR px-0">
                  {{ t(`$vuetify.home.services.services[${index}].description`) }}
                </v-card-text>
              </div>
              <v-card-actions class="px-0">
                <v-btn flat class="cards-btn" variant="flat" color="#101010" rounded="lg">
                  {{ t(`$vuetify.home.services.btn_request_info`) }}
                  <template v-slot:append>
                    <v-icon>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.5 0.886127V7.579C9.5 7.6814 9.45932 7.77962 9.38691 7.85203C9.31449 7.92444 9.21628 7.96512 9.11387 7.96512C9.01147 7.96512 8.91325 7.92444 8.84084 7.85203C8.76843 7.77962 8.72775 7.6814 8.72775 7.579V1.81798L1.14936 9.39637C1.07616 9.46457 0.979349 9.50171 0.879316 9.49994C0.779282 9.49818 0.683839 9.45765 0.613094 9.38691C0.542349 9.31616 0.501825 9.22072 0.50006 9.12068C0.498295 9.02065 0.535427 8.92384 0.603632 8.85064L8.18202 1.27225H2.421C2.3186 1.27225 2.22038 1.23157 2.14797 1.15916C2.07556 1.08675 2.03488 0.988534 2.03488 0.886127C2.03488 0.78372 2.07556 0.685507 2.14797 0.613094C2.22038 0.540681 2.3186 0.5 2.421 0.5H9.11387C9.21628 0.5 9.31449 0.540681 9.38691 0.613094C9.45932 0.685507 9.5 0.78372 9.5 0.886127Z"
                          fill="#EEAC47" />
                      </svg>
                    </v-icon>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useLocale } from "vuetify";
import ContactUsModal from "../Modals/ContactUsModal.vue";

export default {
  name: 'ServicesPage',
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  components: {
    ContactUsModal
  },
  data: () => ({
    services: [
      {
        href: "#",
        //title: "Professional Chauffeur Services",
        vip: true,
      },
      {
        href: "#",
        //title: "Limousine Services",
        vip: true,
      },
      {
        href: "#",
        //title: "Yachcharter Services",
        vip: true,
      },
      {
        href: "#",
        //title: "Private Flights",
        vip: true,
      },
      {
        href: "#",
        //title: "VIP Transfers",
        vip: true,
      },
    ]
  }),
  mounted() {
    /* const row = document.querySelector('.row-services');
    let startY;
    let startScrollLeft;

    row.addEventListener('touchstart', (e) => {
      startY = e.touches[0].pageY;
      startScrollLeft = row.scrollLeft;
    });
    row.addEventListener('touchmove', (e) => {
      const currentY = e.touches[0].pageY;
      const deltaY = currentY - startY;
      if (deltaY < 0 && row.scrollLeft + window.innerWidth < row.scrollWidth) {
        //down
        e.preventDefault();
        row.scrollLeft = startScrollLeft - deltaY;
      } else if (deltaY > 0 && row.scrollLeft > 0) {
        //up
        e.preventDefault();
        row.scrollLeft = startScrollLeft - deltaY;
      }
    }); */
  },
  methods: {
    OpenModal() {
      this.$refs.OpenContactUsModal.dialog = true;
      //this.$refs.OpenContactUsModal.property = card;
    },
  }
}
</script>

<style scoped>
.cards-services:hover {
  background: #101010;
}

.cards-services:hover .cards-title-text {
  color: #E6E8EB;
}

.cards-services:hover .cards-btn {
  background-color: #E6E8EB !important;
  color: #101010 !important;
}

.vip-text {
  background: #101010;
  color: #FFFFFF;
  border-radius: 10px;
  font-size: 0.8rem;
  width: auto;
  text-align: center;
  height: min-content;
}

.cards-btn {
  text-transform: inherit;
}

.cards-title-text {
  white-space: break-spaces;
  text-wrap: balance;
  color: #000000;
  font-size: 1.8rem;
  line-height: 2.2rem;
  min-height: 114px;
}

.cards-text {
  white-space: break-spaces;
  text-wrap: balance;
  color: #737475;
  font-size: 1rem;
  min-height: 220px;
}

.cards-services {
  border: 1px solid rgba(154, 154, 155, 0.5);
  border-radius: 15px;
  background: transparent;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.discover-img {
  border-radius: 15px;
}

.text-title {
  color: #343330;
  font-weight: 300;
  font-size: 5.5rem;
  line-height: 7rem;
  text-align: left;
  text-transform: uppercase;
}


.container-main {
  padding-top: 10vh;
  padding-bottom: 10vh;
  position: relative;
  z-index: 1;
}

.svg-animation {
  overflow: visible;
  transform-origin: 50% 50%;
  animation-name: svg-anim;
  animation-duration: 18s;
  animation-direction: normal;
  animation-timing-function: linear;
  transform: rotate(0deg);
  animation-iteration-count: infinite;
}

@keyframes svg-anim {
  from {
    transform: rotate(-360deg);
  }

  to {
    transform: rotate(0deg);
  }
}


@media (min-width: 600px) and (max-width: 960px) {
  .text-title {
    font-size: 3.8rem;
    font-weight: 300;
    line-height: 5rem;
  }

}

@media (max-width: 600px) {
  .text-title {
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 3rem;
  }

  /* .row-services {
    overflow: auto;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    justify-content: flex-start !important;

  }

  .row-services {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .row-services::-webkit-scrollbar {
    display: none;
  } */
}
</style>